// extracted by mini-css-extract-plugin
export default {"container":"Shishka_container__T7xCC","navbar":"Shishka_navbar__gWvUx","page":"Shishka_page__abS7n"};